import { lazy } from 'react';
import { authRoles } from 'app/auth';

const DataCategoryGroupAppConfig = {
	settings: {
		layout: {}
	},
	auth: authRoles.admin,
	routes: [
		{
			exact: true,
			path: '/apps/settings/admin-category-group',
			component: lazy(() => import('./list/Datas'))
		},
		{
			exact: true,
			path: '/apps/settings/admin-category-group/:id',
			component: lazy(() => import('./addEdit/Data'))
		}
	]
};

export default DataCategoryGroupAppConfig;
